import React, { FC } from 'react';
import { Label, Radio } from 'flowbite-react';
import { t } from 'i18next';

interface EditRadioGroupProps {
  label: string;
  options: string[];
  selectedValue: string | null;
  onChange: (value: string) => void;
  optionName: string;
}

export const EditRadioGroup: FC<EditRadioGroupProps> = ({
  label,
  options,
  selectedValue,
  onChange,
  optionName,
}) => (
  <div className="mb-4">
    <label className="block text-sm font-bold text-gray-700">{label}</label>
    <div className="mt-2 flex gap-2">
      {options.map((option) => (
        <div className="flex items-center gap-2" key={option}>
          <Radio
            id={option.toLowerCase()}
            name={label}
            value={option}
            checked={selectedValue === option}
            onChange={() => onChange(option)}
          />
          <Label htmlFor={option.toLowerCase()}>
            {t(`${optionName}.${option}`)}
          </Label>
        </div>
      ))}
    </div>
  </div>
);
